import { Inject, Injectable } from '@angular/core';
import { CustomAmplitudeEvent } from 'src/app/domain/models/amplitude.model';
import { IEventTrackingPort } from 'src/app/domain/ports/i-event-tracking-port';

@Injectable({
  providedIn: 'root'
})
export class EventTrackingService implements IEventTrackingPort{
  constructor(
    @Inject('IEventTrackingPort') private eventTrackingAdapter: IEventTrackingPort
  ){}

  trackEvent(nameEvent: string, data?: CustomAmplitudeEvent) {
    return this.eventTrackingAdapter.trackEvent(nameEvent, data);
  }

  downloadEvent(nameEvent: string, data?: CustomAmplitudeEvent) {
    return this.eventTrackingAdapter.downloadEvent(nameEvent, data);
  }
}
